import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  TextField,
  Box,
  Modal,
  IconButton,
  Typography,
  TablePagination,
  FormControl,
  Select,
} from "@mui/material";
import { InputLabel } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Close } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";

import { useFetch } from "../../hooks";
import { urls } from "../../urls/urls";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { useSelector } from "react-redux";
// Import local images
import image1 from "../../assets/images/image1.jpg";
import image2 from "../../assets/images/image2.jpg";
import image3 from "../../assets/images/image3.jpg";

const AdminVendorAddBanners = () => {
  const loginToken = useSelector((state) => state.user.logintoken);
  const {
    data: vendorProductsData,
    error: vendorProductsError,
    fetchData: fetchVendorProducts,
  } = useFetch(BASE_URL_TEST + urls("getAllVProductsNoId"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({
    vendorId: "",
    productId: "",
    category: "",
    subcategory: "",
    title: "",
    salesPrice: "",
    status: "Active",
    description: "",
    image: "",
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [previewImage, setPreviewImage] = useState(null);
  const getInitialFormValues = () => ({
    category_id: isEditMode ? selectedBrand.category_id : "",
    vendor_id: isEditMode ? selectedBrand.vendor_id : "",
    vendor_product_id: isEditMode ? selectedBrand.vendor_product_id : "",
    sub_cat_id: isEditMode ? selectedBrand.sub_cat_id : "",
    sub_cat_name: isEditMode ? selectedBrand.sub_cat_name : "",
    product_id: isEditMode ? selectedBrand.product_id : "",
    product_name: isEditMode ? selectedBrand.product_name : "",
    vlisting_id: isEditMode ? selectedBrand.vlisting_id : "",
    brand_id: isEditMode ? selectedBrand.brand_id : "",
    brand_name: isEditMode ? selectedBrand.brand_name : "",
    name: isEditMode ? selectedBrand.name : "",
    salePrice: isEditMode ? selectedBrand.salePrice : "",
    quantity: isEditMode ? selectedBrand.quantity : "",
    self_delivery: isEditMode ? selectedBrand.self_delivery : "",
    self_pickup: isEditMode ? selectedBrand.self_pickup : "",
    description: isEditMode ? selectedBrand.description : "",
    images: isEditMode ? selectedBrand.images : "",
    vendor: isEditMode ? selectedBrand.vendor : "",
    category_name: isEditMode ? selectedBrand.category_name : "",
    badge_id: isEditMode ? selectedBrand.badge_id : "",
    badge_name: isEditMode ? selectedBrand.badge_name : "",
    ribbon_id: isEditMode ? selectedBrand.ribbon_id : "",
    ribbon_name: isEditMode ? selectedBrand.ribbon_name : "",
    regularPrice: isEditMode ? selectedBrand.regularPrice : "",
    sale_price: isEditMode ? selectedBrand.sale_price : "",
    variantData: isEditMode ? selectedBrand.variantData : "",
    status: isEditMode ? selectedBrand.status : "",
    name: isEditMode ? selectedBrand.name : "",
    product_description: isEditMode ? selectedBrand.product_description : "",
    tags: isEditMode ? selectedBrand.tags : "",
    sku: isEditMode ? selectedBrand.sku : "",
    discount: isEditMode ? selectedBrand.discount : "",
    badge: isEditMode ? selectedBrand.badge : "",
    badge: isEditMode ? selectedBrand.badge : "",
    brnad: isEditMode ? selectedBrand.brnad : "",
    ribbon: isEditMode ? selectedBrand.ribbon : "",
    trashould_quantity: isEditMode ? selectedBrand.trashould_quantity : "",
    stock_quantity: isEditMode ? selectedBrand.stock_quantity : "",
    self_delivery: isEditMode ? selectedBrand.self_delivery : 0,
    self_pickup: isEditMode ? selectedBrand.self_pickup : 0,
    cod_allowed: isEditMode ? selectedBrand.cod_allowed : 0,
    is_retuanable: isEditMode ? selectedBrand.is_retuanable : 0,
    is_cancelable: isEditMode ? selectedBrand.is_cancelable : 0,
    images: isEditMode ? selectedBrand.images : [],
    image_ids: isEditMode ? selectedBrand.image_ids : "",
    badge_name: isEditMode ? selectedBrand.badge_name : "",
    description: isEditMode ? selectedBrand.description : "",
    status: isEditMode ? selectedBrand.status : 0,
  });

  const [brands, setBrands] = useState(getInitialFormValues());
  const [vendorProducsAllData, setVendorProductsAllData] = useState([]);
  const handleSearch = (event) => setSearch(event.target.value);

  const handleMenuOpen = (event, brand) => {
    console.log("menuOpne", brand);
    setIsEditMode(true);
    setAnchorEl(event.currentTarget);
    setSelectedBrand(brand);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleView = (event, brand) => {
    // setForm(selectedBrand)
    console.log("selectedProdadmin", brand);

    setAnchorEl(event.currentTarget);
    setIsEditMode(true);

    setSelectedBrand(brand);
    setSelectedBrand(brand);
    setBrands({
      vendor_product_id: brand.vendor_product_id || "",
      product_id: brand.product_id || "",
      category_name: brand.category_name || "",
      sub_cat_name: brand.sub_cat_name || "",
      name: brand.name || "",
      sale_price: brand.sale_price || "",
      status: brand.status === 1 ? "Active" : "Inactive",
      description: brand.description || "",
      vendor: brand.vendor || "",
      category_id: brand.category_id || "",
      product_description: brand.product_description || "",

      vendor_id: brand.vendor_id || "",
      images: brand.images || [],
      status: brand.status || 0,
    });

    setModalOpen(true);
    handleMenuClose();
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setForm({
      vendorId: "",
      productId: "",
      category: "",
      subcategory: "",
      title: "",
      salesPrice: "",
      status: "Active",
      description: "",
      image: "",
    });
    setIsEditMode(false);
    setPreviewImage(null); // Reset preview image on close
  };

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    setForm({ ...form, image: URL.createObjectURL(e.target.files[0]) });
    setPreviewImage(URL.createObjectURL(e.target.files[0])); // Set the preview image
  };

  form.images = [image1, image2, image3]; // Add local images to form.images

  useEffect(() => {
    fetchVendorProducts();
  }, []);

  useEffect(() => {
    if (vendorProductsData && vendorProductsData.status === true) {
      setVendorProductsAllData(vendorProductsData.data);
    } else if (vendorProductsError) {
      console.error("Error fetching vendor products:", vendorProductsError);
    }
  }, [vendorProductsData, vendorProductsError]);

  const handleSubmit = () => {
    if (form.title && form.productId && form.vendorId) {
      if (isEditMode) {
        setBrands(
          brands.map((b) =>
            b.id === selectedBrand.id ? { ...b, ...form } : b,
          ),
        );
      } else {
        setBrands([...brands, { id: Date.now(), ...form, status: "Active" }]);
      }
    }
    handleModalClose();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
const filteredBrands =
  vendorProducsAllData &&
  vendorProducsAllData.filter((brand) =>
    brand?.name?.toLowerCase().includes(search.toLowerCase()),
  );

  const handleImageClick = (imageUrl) => {
    setPreviewImage(imageUrl); // Set clicked image as preview
  };

  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{ width: "30%", backgroundColor: "#FFF", borderRadius: 1 }}
        />
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Vendor ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Product ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Subcategory</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Title</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Sales Price</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBrands &&
              Array.isArray(filteredBrands) &&
              filteredBrands
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((brand) => (
                  <TableRow key={brand.vendor_product_id}>
                    <TableCell>{brand.vendor_id}</TableCell>
                    <TableCell>{brand.product_id}</TableCell>
                    <TableCell>{brand.category_name}</TableCell>
                    <TableCell>{brand.sub_cat_name}</TableCell>
                    <TableCell>
                      {Array.isArray(brand["images"]) &&
                      brand.images.length > 0 ? (
                        <img
                          src={brand?.images[0]["image_url"]}
                          alt="logo"
                          width={40}
                          height={40}
                          onClick={() => handleImageClick(brand.image)} // Click to open image preview
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        "No Image"
                      )}
                    </TableCell>
                    <TableCell>{brand.name}</TableCell>
                    <TableCell>{brand.sale_price}</TableCell>
                    <TableCell>
                      <Typography
                        color={
                          brand.status === 1
                            ? "green"
                            : brand.status === 0
                              ? "red"
                              : "orange"
                        }
                      >
                        {brand.status === 1 ? "Active" : "InActive"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <MoreVertIcon onClick={(e) => handleView(e, brand)} />
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={() => {}}>View</MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredBrands && filteredBrands.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* Modal for Image Preview (Popup) */}
      <Modal open={previewImage !== null} onClose={() => setPreviewImage(null)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxWidth: 700,
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
            p: 4,
            textAlign: "center",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setPreviewImage(null)}
          >
            <Close />
          </IconButton>
          <img
            src={previewImage}
            alt="Large Preview"
            style={{
              width: "100%",
              maxWidth: "600px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Modal>

      <Modal open={modalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 700,
            height: "auto",
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
            p: 4,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={handleModalClose}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" mb={2}>
            {isEditMode ? "View Product Details" : "Add Slider"}
          </Typography>
          <TextField
            name="vendorId"
            label="Vendor ID"
            fullWidth
            margin="dense"
            value={brands.vendor_id}
            onChange={(e) =>
              setBrands({ ...brands, vendor_id: e.target.value })
            }
          />
          <TextField
            name="productId"
            label="Product ID"
            fullWidth
            margin="dense"
            value={brands.product_id}
            onChange={(e) =>
              setBrands({ ...brands, product_id: e.target.value })
            }
          />
          <TextField
            name="category"
            label="Category"
            fullWidth
            margin="dense"
            value={brands.category_name}
            onChange={(e) =>
              setBrands({ ...brands, category_name: e.target.value })
            }
          />
          <TextField
            name="subcategory"
            label="Subcategory"
            fullWidth
            margin="dense"
            value={brands.sub_cat_name}
            onChange={(e) =>
              setBrands({ ...brands, sub_cat_name: e.target.value })
            }
          />
          <TextField
            name="title"
            label="Title"
            fullWidth
            margin="dense"
            value={brands.name}
            onChange={(e) => setBrands({ ...brands, name: e.target.value })}
          />
          <TextField
            name="salesPrice"
            label="Sales Price"
            fullWidth
            margin="dense"
            value={brands.sale_price}
            onChange={(e) =>
              setBrands({ ...brands, salePrice: e.target.value })
            }
          />
          <TextField
            name="description"
            label="Description"
            fullWidth
            margin="dense"
            value={brands.product_description}
            onChange={handleInputChange}
            multiline
            rows={4}
          />
          {isEditMode ? (
            <FormControl fullWidth sx={{ mb: 5, mt: 2 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={brands.status || 0} // Default to 1 (Active)
                onChange={(e) => {
                  console.log("select", e.target.value);
                  setBrands((prev) => ({
                    ...brands,
                    status: e.target.value,
                  }));
                }}
                label="Status"
              >
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={0}>Deactive</MenuItem>
              </Select>
            </FormControl>
          ) : (
            ""
          )}
          <Box sx={{ mt: 2 }}>
            {brands.images &&
            Array.isArray(brands["images"]) &&
            brands.images.length > 0 ? (
              brands.images.map((image, index) => (
                <img
                  key={index}
                  src={image["image_url"]}
                  alt={`preview-${index}`}
                  width={100}
                  height={100}
                  style={{
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={() => setPreviewImage(image["image_url"])} // Preview image click
                />
              ))
            ) : (
              <Typography variant="body2" color="textSecondary">
                No images available
              </Typography>
            )}
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleModalClose}
            >
              Cancel
            </Button>
            <Button variant="contained" color="success" onClick={handleSubmit}>
              {isEditMode ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AdminVendorAddBanners;
